module.exports = __webpack_public_path__ + "img/17873_L.bdbee449.png";